<template>
  <div 
    :style="{
      backgroundImage: `url(${require('@/assets/img/page_bg.png')})`,
    }"
  >
    <section class="body-sign">
      <div class="center-sign">
        <a href="/" class="logo float-left mt-3"
          :style="{
                backgroundImage: `url(${require('@/assets/img/login_bg.png')})`,
                width: `${logoWidth} px`,
              }"
        >
          <img src="@/assets/img/logo.png" height="54" alt="Porto Admin" :width="logoWidth"/>
        </a>

        <div class="panel card-sign">
          <div class="card-title-sign mt-3 text-right">
            <h2 class="title text-uppercase font-weight-bold m-0"><i class="fas fa-user mr-1"></i> Sign Up</h2>
          </div>
          <div class="card-body">
            <div v-if="provider" class="alert alert-success" role="alert">
              You've successfully authenticated with <strong>{{provider}}</strong>.
              <button @click="clear" type="button" class="close" data-dismiss="alert">
                <span>&times;</span>
              </button>
            </div>
            <v-form @submit="submit">
              <div class="form-group mb-3">
                <label>Name</label>
                <input required v-model="form.name" name="name" type="text" class="form-control form-control-lg" />
              </div>

              <div class="form-group mb-3">
                <label>E-mail Address</label>
                <input required v-model="form.email" name="email" type="email" class="form-control form-control-lg" />
              </div>

              <div class="form-group mb-0">
                <div class="row">
                  <div class="col-sm-6 mb-3">
                    <label>Password</label>
                    <input required v-model="form.password" name="pwd" type="password" class="form-control form-control-lg" />
                  </div>
                  <div class="col-sm-6 mb-3">
                    <label>Password Confirmation</label>
                    <input required name="pwd_confirm" type="password" class="form-control form-control-lg" />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-8">
                  <div class="checkbox-custom checkbox-default">
                    <input required id="AgreeTerms" name="agreeterms" type="checkbox" />
                    <label for="AgreeTerms">I agree with <a href="#">terms of use</a></label>
                  </div>
                </div>
                <div class="col-sm-4 text-right">
                  <button type="submit" class="btn btn-primary mt-2">Sign Up</button>
                </div>
              </div>

              <span class="mt-3 mb-3 line-thru text-center text-uppercase">
                <span>or</span>
              </span>

              <div class="mb-1 text-center">
                <!-- <a class="btn btn-facebook mb-3 ml-1 mr-1" href="/api/authentication/sign-in/facebook">Connect with <i class="fab fa-facebook-f"></i></a> -->
                <a class="btn btn-success mb-3 ml-1 mr-1" href="/api/authentication/sign-in/azure-ad">Connect with Azure AD</a>
                <!-- <a class="btn btn-warning mb-3 ml-1 mr-1" href="/api/authentication/sign-in/keycloak">Connect with Keycloak</a> -->
              </div>

              <p class="text-center">Already have an account? <router-link to="/login">Sign In!</router-link>
              </p>

            </v-form>
          </div>
        </div>

        <p class="text-center text-muted mt-3 mb-3">&copy; Copyright 2017. All Rights Reserved.</p>
      </div>
    </section>
  </div>
  
</template>

<script>
import helper from "@/helpers/signInHelper";
import VForm from "@/views/shared/form";
export default {
  components: { VForm },
  data() {
    return {
      text: null,
      provider: null,
      form: {
        name: null,
        email: null,
        password: null
      }
    };
  },
  computed: {
    logoWidth() {
      return window.innerWidth > 500 ? '' : 237;
    },
  },
  mounted() {
    this.$http.get("/api/authentication/sign-in/callback").then(
      a => {},
      a => {
        this.provider = a.body.provider;
        this.form.name = a.body.info.name;
        this.form.email = a.body.info.email;
      }
    );
  },
  methods: {
    clear() {
      this.$http.delete("/api/authentication/clear");
    },
    submit(e) {
      this.$http.post("/api/authentication/sign-up", this.form).then(
        a => {
          helper.signIn(a.body.token);
        },
        a => {
          alert(a.body.errors.map(a => a.description).join("\r\n"));
        }
      );
    }
  }
};
</script>
